import type { TicketTax, TaxesByTicket } from './types'

export function roundCurrency(n: number): number {
  return Math.round(n * 100) / 100
}

/**
 * Convert a foreign-filed TAX amount to booking currency. Sabre BSR convention rounds taxes to the
 * nearest 0.1 unit and fares/penalties to the whole unit — so fare/penalty conversions round at
 * their own call sites and must not go through here.
 */
export function inBookingCurrency(raw: number, currencyCode: string, bookingCurrency: string, fxRate: number): number {
  return currencyCode === bookingCurrency ? raw : Math.round(raw * fxRate * 10) / 10
}

export function taxAmount(tax: TicketTax, bookingCurrency: string, fxRate: number): number {
  return inBookingCurrency(parseFloat(tax.amount) || 0, tax.currencyCode, bookingCurrency, fxRate)
}

/** Sum all taxes for the given ticket numbers, converted to booking currency. */
export function sumTicketTaxes(
  ticketNumbers: Iterable<string>,
  taxesByTicket: TaxesByTicket | undefined,
  bookingCurrency: string,
  fxRate: number,
): number {
  let total = 0
  for (const n of ticketNumbers) {
    for (const tax of taxesByTicket?.[n] ?? []) total += taxAmount(tax, bookingCurrency, fxRate)
  }
  return total
}
